// Import utils
import { getDocumentElement, getDocumentElements } from "../../Utils/Utils";

/**
 * Handle the calculation of the total sum.
 * 
 * @param       {array}     fields
 * 
 * @returns     {void}
 */
const UpdateWaterSupplyTotalHandler = (fields, finalSummary) => {
    let sum = 0;

    fields.forEach(field => {
        sum += Number(field.value);
    });

    finalSummary.value = sum.toFixed(3);
};

/**
 * Pull in all the necessary field data for the final summary.
 * 
 * @returns     {void}
 */
export const UpdateWaterSupplyTotal = () => {
    setInterval(() => {
        // Retrieve the summary fields
        const SummaryFields = getDocumentElements('.farm-calc-section--supply [id^="tot_"]');
        const FinalSummary = getDocumentElement('#waterSupplyTotal');

        if (SummaryFields && FinalSummary) {
            UpdateWaterSupplyTotalHandler(SummaryFields, FinalSummary);
        }
    }, 200);
};